export const useRecipeStockItemsKeys = () => {
  const recipeStockItemsKeys = {
    all: ["recipe-stock-items"],
    list: (recipeId) => [...recipeStockItemsKeys.all, "list", recipeId],
    detail: (recipeId, stockId) => [
      ...recipeStockItemsKeys.all,
      "detail",
      recipeId,
      stockId,
    ],
  };
  return { recipeStockItemsKeys };
};
